import React from 'react';
import { Bookmark } from 'react-feather';
import Button from 'seedly-component-library/button-new';
import { useRouter } from 'next/router';

interface OwnProps {
  discoveryRoute: string;
  contentType: string;
  buttonTitle: string;
}

const DiscoveryContentCard = (props: OwnProps) => {
  const router = useRouter();

  const { discoveryRoute, contentType, buttonTitle } = props;

  return (
    <div className="p-4 bg-white rounded center-in-div h-[150px] w-full">
      <div className="flex flex-col items-center gap-4">
        <p className="text-base font-bold text-center">
          To save {contentType}, tap Save{' '}
          <Bookmark className="inline pb-1" size={16} /> <br /> when you find
          the one that interest you
        </p>
        <Button
          onClick={() => {
            router.push(discoveryRoute);
          }}
        >
          {buttonTitle || 'Discover Content'}
        </Button>
      </div>
    </div>
  );
};

export default DiscoveryContentCard;
